import { useAuthStore } from "@/contexts/AuthContext";
import { togglePostHog } from "@/util/analytics";
import { useEffect } from "react";

export default function PostHogController() {
  const { org } = useAuthStore();

  useEffect(() => {
    if (typeof org?.enablePostHog === "boolean") {
      togglePostHog(org.enablePostHog);
    }
  }, [org]);

  return null;
}
